import { CONFIG, type Entry, type Fixture } from '@h2h/shared';
import { StakeLadder } from '../../../components/play/cycling-ui';
import { buildStageLadder } from './buildStageLadder';

const PICKS_REQUIRED = CONFIG.CYCLING.DUELS_PER_STAGE;

/** Read-only hub ladder for a completed stage entry — same chrome as Compete. */
export function StageStakeLadder({
  entry,
  fixtures,
  stageLive,
  onOpenDuel
}: {
  entry: Entry;
  fixtures: Fixture[];
  stageLive: boolean;
  onOpenDuel: (duelId: string) => void;
}) {
  const { rungs, weights, grades } = buildStageLadder(entry, fixtures);

  if (rungs.length < PICKS_REQUIRED) return null;

  return (
    <div className="mt-3">
      <StakeLadder
        rungs={rungs}
        weights={weights}
        readOnly
        rungGrades={grades}
        stageLive={stageLive}
        onRungPress={onOpenDuel}
        footerHint="Tap a duel for details"
        rankedCount={PICKS_REQUIRED}
        total={PICKS_REQUIRED}
      />
    </div>
  );
}
